export default [
  {
    name: "atItemSetting",
    path: "/attendance/itemSetting",
    component: () => import("@/views/attendance/itemSetting/index.vue"),
    meta: {
      title: "考勤项目配置",
    },
  },
  {
    name: "cardRecord",
    path: "/attendance/cardRecord",
    component: () => import("@/views/attendance/cardRecord/index.vue"),
    meta: {
      title: "打卡记录",
    },
  },
  {
    name: "otherSetting",
    path: "/attendance/otherSetting",
    component: () => import("@/views/attendance/otherSetting/index.vue"),
    meta: {
      title: "其他配置",
    },
  },
  {
    name: "shiftSetting",
    path: "/attendance/shiftSetting",
    component: () => import("@/views/attendance/shiftSetting/index.vue"),
    meta: {
      title: "班次设置",
    },
  },
  {
    name: "scheduling",
    path: "/attendance/scheduling",
    component: () => import("@/views/attendance/scheduling/index.vue"),
    meta: {
      title: "排班管理",
    },
  },
  {
    name: "summaryIndex",
    path: "/attendance/summary",
    component: () => import("@/views/attendance/summary/index.vue"),
    meta: {
      title: "月度汇总",
    },
  },
  {
    name: "holidayRules",
    path: "/attendance/holidayManagement/holidayRules",
    component: () =>
      import("@/views/attendance/holidayManagement/holidayRules/index.vue"),
    meta: {
      title: "假期规则",
    },
  },
  {
    name: "holidayAmount",
    path: "/attendance/holidayManagement/holidayAmount",
    component: () =>
      import("@/views/attendance/holidayManagement/holidayAmount/index.vue"),
    meta: {
      title: "假期额度",
    },
  },
  {
    name: "companyHoliday",
    path: "/attendance/holidayManagement/companyHoliday",
    component: () =>
      import("@/views/attendance/holidayManagement/companyHoliday/index.vue"),
    meta: {
      title: "企业假期",
    },
  },
  {
    name: "attendanceCheck",
    path: "/attendance/attendanceCheck/index",
    component: () => import("@/views/attendance/attendanceCheck/index.vue"),
    meta: {
      title: "考勤核对",
    },
  },
  {
    name: "attendanceFormIndex",
    path: "/attendance/attendanceForm/index",
    component: () => import("@/views/attendance/attendanceForm/index.vue"),
    meta: {
      title: "考勤单据",
    },
  },
];
